<template>
  <b-modal
    ref="modal-deal-sheet-import"
    hide-footer
    :title="titleExcel"
    id="modal-deal-sheet-import"
    no-close-on-backdrop
    size="xl"
  >
    <div>
      <b-row>
        <b-col>
          <div class="form-group">
            <span>
              <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
              format, hoặc có thể tải ở
              <a :href="urlExcel">đây</a>
            </span>
          </div>
        </b-col>
      </b-row>
      <span> <b>Bước 2:</b> Tiến hành Import </span>
      <b-row>
        <b-col>
          <UploadFileMulter
            v-on:send-file="getDataFromExcel"
            v-on:clear-file="clearFileExcel"
            :cmdUrl="'v1/deal-sheets/import-excel/'"
          />
          <span v-if="fileName"
            >Tên file: <b>{{ fileName }}</b>
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="mt-10" v-show="importItems.length !== 0">
      <hr
        class="hr-text"
        data-content="Danh sách dealsheet"
        style="font-weight: 600"
      />
      <b-table
        class="myTable"
        caption-top
        responsive
        bordered
        hover
        :fields="fields"
        :items="importItems"
        id="my-table"
        :per-page="10"
        :current-page="currentPage"
        :busy="isBusy"
      >
        <template #cell(index)="data">
          {{ data.item.index }}
        </template>
        <template #cell(type)="data">
          {{ dealsheetProgramTypeName(data.item.type) }}
        </template>
        <template #cell(isActive)="data">
          <span v-text="dealsheetStatusName(data.item.isActive)"> </span>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle ml-3"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template #cell(errors)="data">
          <div>
            <ul
              class="mb-0 pl-3"
              style="font-size: 12px"
              v-if="!data.item.isValid"
            >
              <li
                v-for="(error, idx) in data.item.errors"
                :key="idx"
                class="text-danger"
              >
                {{ error }}
              </li>
            </ul>
            <ul class="mb-0 pl-3" style="font-size: 12px" v-else>
              <li class="text-success">Hợp lệ</li>
            </ul>
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <i
            class="flaticon2-rubbish-bin-delete-button text-danger"
            @click="
              showDeleteAlert(
                'Xoá',
                `Bạn có chắc muốn xoá ${row.item.code}`,
                row.item,
                conFirmDel,
              )
            "
            role="button"
          >
          </i>
        </template>
      </b-table>
      <b-col class="row mt-3">
        <b>
          Tổng số:
          {{ importItems.length || 0 }}
        </b>
      </b-col>
      <b-pagination
        class="custom-pagination"
        v-show="importItems.length > 10"
        v-model="currentPage"
        :total-rows="rows()"
        :per-page="10"
        aria-controls="my-table"
        align="right"
      ></b-pagination>
    </div>
    <b-button
      style="width: 80px"
      class="mt-6 mr-2"
      v-if="importItems.length"
      variant="primary"
      size="sm"
      @click="onCreateDealSheetThrottle()"
      :disabled="isBusy"
    >
      <strong>Tạo <Spinner :show="isBusy" custom-class="ml-2" /></strong>
    </b-button>
    <b-button
      class="mt-6"
      style="width: 80px"
      variant="secondary"
      size="sm"
      @click="hideModalExcel"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>
<script>
import { DATE_FORMAT } from '@/utils/constants';
import { makeToastSuccess, handleError } from '@/utils/common';
import ApiService from '@/core/services/api.service';
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import {
  DEAL_SHEET_TARGET_TYPE_NAME,
  ACTIVE_STATUS_COMMON_NAME,
} from '@/utils/enum-name';
import _ from 'lodash';
import { showDeleteAlert } from '@/utils/sweet-alert2.js';
import { formatDate } from '@/utils/date';
import { initDealSheetPayload } from '@/view/pages/dealsheets/utils/formHelper';
import permissionMixin from '@/view/mixins/permission.mixin';
import Spinner from '@/view/base/design-system/molecules/Spinner.vue';
import { URL_IMPORT_DEALSHEET } from '@/utils/constants';

export default {
  name: 'DealSheetImportExcel',
  mixins: [permissionMixin],
  data() {
    return {
      DATE_FORMAT: DATE_FORMAT,
      titleExcel: 'Nhập excel dealsheet',
      urlExcel: URL_IMPORT_DEALSHEET,
      currentPage: 1,
      importItems: [],
      isBusy: false,
      fileName: '',
      fields: [
        {
          key: 'index',
          label: 'STT',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
        {
          key: 'code',
          label: 'Mã',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'name',
          label: 'Tên chương trình',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'targetMin',
          label: 'ĐK min (%)',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
        },
        {
          key: 'targetMax',
          label: 'ĐK max (%)',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
        },
        {
          key: 'targetType',
          label: 'Loại',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          formatter: (value) => {
            return DEAL_SHEET_TARGET_TYPE_NAME[value];
          },
        },
        {
          key: 'startDate',
          label: 'Ngày bắt đầu',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'endDate',
          label: 'Ngày kết thúc',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'errors',
          label: 'Chi tiết',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '30%' },
          tdClass: 'text-left',
          thClass: 'text-center',
        },
        { key: 'actions', label: '', tdClass: 'text-center' },
      ],
    };
  },
  components: {
    UploadFileMulter,
    Spinner,
  },
  methods: {
    showDeleteAlert,
    formatDate,
    conFirmDel: function (row) {
      this.importItems = this.importItems.filter(
        (item) => item.code !== row.code,
      );
    },
    dealsheetStatusName: function (type) {
      return ACTIVE_STATUS_COMMON_NAME[type];
    },
    hideModalExcel() {
      this.$refs['modal-deal-sheet-import'].hide();

      this.clearFileExcel();
    },
    onCreateDealSheetThrottle: _.throttle(function () {
      this.onCreateDealSheet();
    }, 2000),
    async onCreateDealSheet() {
      if (this.isBusy) return;

      this.isBusy = true;
      try {
        const formattedItems = this.importItems.map((item) => {
          const stores = item.stores || [];
          const details = item.details || [];
          const categories = item.categories || [];

          return initDealSheetPayload(
            {
              id: item.id || null,
              code: item.code || '',
              name: item.name || '',
              startDate: item.startDate,
              endDate: item.endDate,
              targetMin: item.targetMin,
              targetMax: item.targetMax,
              isActive: item.isActive,
              priority: item.priority,
              programType: item.programType,
              targetType: item.targetType,
              isLimit: item.isLimit || false,
              limit: item.limit || 0,
              discountAmount: item.discountAmount || '',
              notApplicablePrograms: item.notApplicablePrograms || [],
              providerId: item.providerId || null,
              subProviderId: item.subProviderId || null,
            },
            stores,
            details,
            categories,
          );
        });

        const result = await ApiService.post(
          'v1/deal-sheets/bulk-create',
          formattedItems,
        );
        makeToastSuccess(result.data.message);
        this.hideModalExcel();
        this.$emit('onRefresh', true);
      } catch (err) {
        handleError(err);
      } finally {
        this.isBusy = false;
      }
    },
    rows() {
      return this.importItems.length;
    },
    getDataFromExcel(data, fileName) {
      this.fileName = fileName;
      this.importItems = [...data.rows].map((item, index) => ({
        ...item,
        stores: item.stores || [],
        details: item.details || [],
        categories: item.categories || [],
        index: index + 1,
      }));
    },
    clearFileExcel() {
      this.importItems = [];
      this.fileName = '';
    },
  },
};
</script>

<style lang="scss">
.modal-deal-sheet-import {
  background-color:aqua table.b-table[aria-busy='true'] {
    opacity: 0.6;
  }

  .modal-dialog.modal-xl {
    max-width: 95vw;
  }
}

#b-toaster-top-right {
  user-select: text;
  z-index: 999999999;
}
</style>
